import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

/** Desktop nav dropdown.
 * Props:
 *   - label: button label
 *   - isActive: highlights the trigger when any child route is active
 *   - items: [{ to?, href?, label, external? }]
 *   - alignRight: align the panel to the right edge of the trigger
 */
export const NavDropdown = ({ label, isActive, items, alignRight = false }) => (
  <div className="relative group">
    <button
      className={`flex items-center gap-1 px-4 py-2 rounded-lg font-medium transition-colors ${
        isActive
          ? 'text-church-green bg-green-50'
          : 'text-slate-700 hover:text-church-green hover:bg-green-50'
      }`}
    >
      {label}
      <ChevronDown className="w-4 h-4" />
    </button>
    <div
      className={`absolute top-full ${
        alignRight ? 'right-0' : 'left-0'
      } mt-1 w-56 bg-white shadow-xl rounded-lg border border-slate-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2`}
    >
      {items.map((it) =>
        it.external ? (
          <a
            key={it.label}
            href={it.href}
            target="_blank"
            rel="noopener noreferrer"
            className="block px-4 py-2 text-slate-700 hover:bg-green-50 hover:text-church-green transition-colors"
          >
            {it.label}
          </a>
        ) : (
          <Link
            key={it.label}
            to={it.to}
            className="block px-4 py-2 text-slate-700 hover:bg-green-50 hover:text-church-green transition-colors"
          >
            {it.label}
          </Link>
        )
      )}
    </div>
  </div>
);
